<div [class.rtl]="lang == 'ar'" class="assistant-modal">
    <div class="modal-body">
        <div *ngIf="loading" class="loader">
            <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
        </div>
        <form [formGroup]="addAssistantForm">
            <div class="img-section">
                <div class="assistant-info-wrapper">
                    <label class="assistant-info">{{'edit-assistant.info' | translate}}</label>
                    <div class="avatar-picker" (click)="changeAssistantProfile()"
                        [class.avatar-picker--readonly]="config?.mode === 'view' || completedProfile">
                        <img *ngIf="image" class="avatar-picker__image" src="{{image}}">
                        <svg *ngIf="!image" class="avatar-picker__placeholder" id="assistant"
                            xmlns="http://www.w3.org/2000/svg" width="39.5" height="45.408" viewBox="0 0 39.5 45.408">
                            <path id="Path_1481" data-name="Path 1481"
                                d="M41.4,36.893V30H19v6.893a11.2,11.2,0,0,0,22.4,0Z"
                                transform="translate(-10.452 -9.731)" fill="#707070" />
                            <path id="Path_1482" data-name="Path 1482"
                                d="M26,51.74v3.783l5.17.741,5.17-.741V51.74A12.853,12.853,0,0,1,26,51.74Z"
                                transform="translate(-11.42 -13.449)" fill="#707070" />
                            <path id="Path_1483" data-name="Path 1483" d="M47,35.17A2.585,2.585,0,1,0,47,30Z"
                                transform="translate(-14.325 -9.115)" fill="#707070" />
                            <path id="Path_1484" data-name="Path 1484"
                                d="M10.6,12.553l18.44,6.911,18.44-6.911L29.04,4.1Z" transform="translate(-9.29 -4.1)"
                                fill="#707070" />
                            <path id="Path_1485" data-name="Path 1485"
                                d="M43.478,55H35.723v1.723a.862.862,0,0,1-.741.853l-6.032.862a.849.849,0,0,1-.241,0l-6.032-.862a.862.862,0,0,1-.741-.853V55H14.181a5.185,5.185,0,0,0-5.1,4.308h39.5A5.185,5.185,0,0,0,43.478,55Z"
                                transform="translate(-9.08 -13.9)" fill="#707070" />
                            <path id="Path_1486" data-name="Path 1486"
                                d="M30.064,23.284a.888.888,0,0,1-.3-.052L18,18.82v7.91H42.127V18.82L30.365,23.232a.888.888,0,0,1-.3.052Z"
                                transform="translate(-10.314 -7.006)" fill="#707070" />
                            <path id="Path_1487" data-name="Path 1487" d="M16.585,35.17V30a2.585,2.585,0,0,0,0,5.17Z"
                                transform="translate(-9.761 -9.115)" fill="#707070" />
                        </svg>
                        <svg class="avatar-picker__camera" xmlns="http://www.w3.org/2000/svg" width="25.673"
                            height="25.673" viewBox="0 0 25.673 25.673">
                            <g id="Group_5234" data-name="Group 5234" transform="translate(-348 -189)">
                                <path id="Path_5432" data-name="Path 5432"
                                    d="M12.836,0A12.836,12.836,0,1,0,25.673,12.836,12.851,12.851,0,0,0,12.836,0Zm0,0"
                                    transform="translate(348 189)" fill="#1d71d3" />
                                <g id="camera" transform="translate(353.41 195.492)">
                                    <g id="Group_5233" data-name="Group 5233" transform="translate(0)">
                                        <g id="Group_5232" data-name="Group 5232" transform="translate(0 0)">
                                            <path id="Path_5478" data-name="Path 5478"
                                                d="M15.19,46.727a1.689,1.689,0,0,0-1.24-.523H11.471v-.03a1.341,1.341,0,0,0-.4-.971,1.367,1.367,0,0,0-.971-.4H5.616a1.377,1.377,0,0,0-1.389,1.374v.03H1.762a1.689,1.689,0,0,0-1.24.523A1.776,1.776,0,0,0,0,47.966V55.4a1.689,1.689,0,0,0,.523,1.24,1.776,1.776,0,0,0,1.24.523H13.95a1.689,1.689,0,0,0,1.24-.523,1.776,1.776,0,0,0,.523-1.24V47.966A1.689,1.689,0,0,0,15.19,46.727ZM14.936,55.4h-.015a.969.969,0,0,1-.971.971H1.762A.969.969,0,0,1,.792,55.4V47.966A.969.969,0,0,1,1.762,47H4.645a.4.4,0,0,0,.4-.4v-.433a.562.562,0,0,1,.582-.582H10.1a.562.562,0,0,1,.582.582v.433a.4.4,0,0,0,.4.4h2.883a.969.969,0,0,1,.971.971Z"
                                                transform="translate(0 -44.8)" fill="#fff" />
                                            <path id="Path_5479" data-name="Path 5479"
                                                d="M115.674,130.8a3.672,3.672,0,1,0,2.6,1.075A3.681,3.681,0,0,0,115.674,130.8Zm2.031,5.72a2.885,2.885,0,0,1-4.062,0,2.855,2.855,0,0,1-.836-2.031,2.919,2.919,0,0,1,.836-2.031,2.855,2.855,0,0,1,2.031-.836,2.919,2.919,0,0,1,2.031.836,2.855,2.855,0,0,1,.836,2.031A2.8,2.8,0,0,1,117.705,136.52Z"
                                                transform="translate(-107.818 -127.589)" fill="#fff" />
                                            <circle id="Ellipse_655" data-name="Ellipse 655" cx="0.732" cy="0.732"
                                                r="0.732" transform="translate(12.441 3.196)" fill="#fff" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <input #fileUploadInput (change)="onFileSelected($event.target.files)" type="file"
                        style="display: none;"
                        [disabled]="config?.mode==='view' || completedProfile">
                </div>
                <div class="registration">
                    <svg *ngIf="!completedProfile" (click)="showQR()" id="qr-code" xmlns="http://www.w3.org/2000/svg"
                        width="31.57" height="31.57" viewBox="0 0 31.57 31.57">
                        <path id="Path_1454" data-name="Path 1454"
                            d="M11.839,0H0V11.839H11.839ZM9.866,9.866H1.973V1.973H9.866Z" fill="#707070" />
                        <path id="Path_1455" data-name="Path 1455" d="M2,2H5.946V5.946H2Z"
                            transform="translate(1.946 1.946)" fill="#707070" />
                        <path id="Path_1456" data-name="Path 1456"
                            d="M0,21.839H11.839V10H0Zm1.973-9.866H9.866v7.892H1.973Z" transform="translate(0 9.731)"
                            fill="#707070" />
                        <path id="Path_1457" data-name="Path 1457" d="M2,12H5.946v3.946H2Z"
                            transform="translate(1.946 11.677)" fill="#707070" />
                        <path id="Path_1458" data-name="Path 1458"
                            d="M10,0V11.839H21.839V0Zm9.866,9.866H11.973V1.973h7.892Z" transform="translate(9.731)"
                            fill="#707070" />
                        <path id="Path_1459" data-name="Path 1459" d="M12,2h3.946V5.946H12Z"
                            transform="translate(11.677 1.946)" fill="#707070" />
                        <path id="Path_1460" data-name="Path 1460" d="M3.946,7H0v3.946H5.919V8.973H3.946Z"
                            transform="translate(0 6.812)" fill="#707070" />
                        <path id="Path_1461" data-name="Path 1461" d="M7,9h3.946v3.946H7Z"
                            transform="translate(6.812 8.758)" fill="#707070" />
                        <path id="Path_1462" data-name="Path 1462" d="M3,7H6.946V8.973H3Z"
                            transform="translate(2.919 6.812)" fill="#707070" />
                        <path id="Path_1463" data-name="Path 1463" d="M10.946,12H7v1.973H8.973v1.973h1.973V12Z"
                            transform="translate(6.812 11.677)" fill="#707070" />
                        <path id="Path_1464" data-name="Path 1464" d="M6.973,7V8.973H5v1.973H8.946V7Z"
                            transform="translate(4.866 6.812)" fill="#707070" />
                        <path id="Path_1465" data-name="Path 1465" d="M8,4H9.973V7.946H8Z"
                            transform="translate(7.785 3.892)" fill="#707070" />
                        <path id="Path_1466" data-name="Path 1466" d="M9.973,8.973v1.973h3.946V7H8V8.973Z"
                            transform="translate(7.785 6.812)" fill="#707070" />
                        <path id="Path_1467" data-name="Path 1467" d="M7,6H8.973V7.973H7Z"
                            transform="translate(6.812 5.839)" fill="#707070" />
                        <path id="Path_1468" data-name="Path 1468" d="M9,14h3.946v3.946H9Z"
                            transform="translate(8.758 13.624)" fill="#707070" />
                        <path id="Path_1469" data-name="Path 1469" d="M7,14H8.973v3.946H7Z"
                            transform="translate(6.812 13.624)" fill="#707070" />
                        <path id="Path_1470" data-name="Path 1470" d="M9,11h1.973v1.973H9Z"
                            transform="translate(8.758 10.704)" fill="#707070" />
                        <path id="Path_1471" data-name="Path 1471" d="M10.946,5.919V1.973H8.973V0H7V7.892H8.973V5.919Z"
                            transform="translate(6.812)" fill="#707070" />
                        <path id="Path_1472" data-name="Path 1472" d="M12,14h1.973v3.946H12Z"
                            transform="translate(11.677 13.624)" fill="#707070" />
                        <path id="Path_1473" data-name="Path 1473" d="M12,12h3.946v1.973H12Z"
                            transform="translate(11.677 11.677)" fill="#707070" />
                        <path id="Path_1474" data-name="Path 1474" d="M11,13h1.973v1.973H11Z"
                            transform="translate(10.704 12.65)" fill="#707070" />
                        <path id="Path_1475" data-name="Path 1475" d="M10,12h1.973v1.973H10Z"
                            transform="translate(9.731 11.677)" fill="#707070" />
                        <path id="Path_1476" data-name="Path 1476" d="M14,10v1.973h1.973v1.973h1.973V10H14Z"
                            transform="translate(13.624 9.731)" fill="#707070" />
                        <path id="Path_1477" data-name="Path 1477" d="M15.973,13H14v5.919h3.946V14.973H15.973Z"
                            transform="translate(13.624 12.65)" fill="#707070" />
                        <path id="Path_1478" data-name="Path 1478" d="M10,10.973v1.973h5.919V9H11.973v1.973Z"
                            transform="translate(9.731 8.758)" fill="#707070" />
                        <path id="Path_1479" data-name="Path 1479" d="M12,7V8.973h3.946v1.973h3.946V7H12Z"
                            transform="translate(11.677 6.812)" fill="#707070" />
                    </svg>
                    <!-- {{'edit-parent.deactivate' | translate}} -->
                    <span *ngIf="completedProfile">{{'edit-assistant.registered' | translate}}</span>
                    <span *ngIf="!completedProfile">{{'edit-assistant.unregistered' | translate}}</span>
                </div>
            </div>
            <div class="secondary-info">
                <div class="row">
                    <div class="secondary-info-text-section col-lg-6">
                        <mat-form-field appearance="outline" dir="ltr">
                            <mat-label>{{'edit-assistant.assistant-name' | translate}}</mat-label>
                            <input matInput formControlName="name"
                                [readonly]="config?.mode === 'view' || completedProfile">
                            <mat-error>{{getValidationError('name')}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="national-id" dir="ltr">
                            <mat-label>{{'edit-assistant.id-number' | translate}}</mat-label>
                            <input matInput formControlName="national_id"
                                [readonly]="config?.mode==='view' || completedProfile" data-pii="redact">
                            <mat-error>{{getValidationError('national_id')}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" dir="ltr">
                            <mat-label>{{'edit-assistant.gender' | translate}}</mat-label>
                            <mat-select formControlName="gender" panelClass="assistantGenderClass"
                                [disabled]="config?.mode==='view' || completedProfile">
                                <mat-option value="female">
                                    {{'edit-assistant.female' | translate}}</mat-option>
                                <mat-option value="male">
                                    {{'edit-assistant.male' | translate}}</mat-option>
                                <!-- <mat-option value="noassistantGender">
                                    {{'edit-assistant.noGender' | translate}}</mat-option> -->
                            </mat-select>
                            <mat-error>{{'edit-assistant.gender-required' | translate}}</mat-error>
                        </mat-form-field>
                        <!-- <mat-form-field appearance="outline">
                        <mat-label>ٌRelative Type</mat-label>
                        <mat-select formControlName="type">
                            <mat-option value="father" [disabled]="config?.mode==='view' || completedProfile">
                                Father</mat-option>
                            <mat-option value="mother" [disabled]="config?.mode==='view' || completedProfile">
                                mother</mat-option>
                        </mat-select>
                        <mat-error>Relative Type Is Required</mat-error>
                    </mat-form-field> -->
                        <div class="phone-no">
                            <mat-form-field class="code" appearance="outline" dir="ltr">
                                <mat-label>{{'edit-assistant.code' | translate}}</mat-label>
                                <mat-select formControlName="country_code" [disabled]="config?.mode==='view'">
                                    <ng-container *ngFor="let country of countries">
                                        <mat-option *ngIf="country.selected" [value]="country?.code_plus">
                                            <table [ngStyle]="{'direction': lang == 'ar' ? 'rtl' : 'ltr'}">
                                                <tr>
                                                    <td>
                                                        <img style="margin-inline-end:5px;" [src]="country?.flag"
                                                            [alt]="country?.short"
                                                            [title]="lang == 'ar'? country.name_ar : country.name">
                                                    </td>
                                                    <td>
                                                        <!-- +{{country?.code | arabicNumber: lang}} translate code -->
                                                        {{country?.code_plus}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                                <mat-error>{{'edit-assistant.code-required' | translate}}</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline" dir="ltr">
                                <mat-label>{{'edit-assistant.phone' | translate}}</mat-label>
                                <input matInput formControlName="phone" [readonly]="config?.mode === 'view'" data-pii="redact">
                                <mat-error>{{getValidationError('phone')}}</mat-error>
                            </mat-form-field>
                        </div>
                        <mat-form-field appearance="outline" dir="ltr">
                            <mat-label>{{'edit-assistant.email' | translate}}</mat-label>
                            <input matInput formControlName="email" [readonly]="config?.mode==='view'">
                            <mat-error>{{getValidationError('email')}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="secondary-info-map-section col-lg-6">
                        <app-map [mapView]="mapView" [mapControls]="mapControls" [showSearchBar]="false"
                            [showCurrentLocationBtn]="false" [showMarker]="true" [isMarkerDraggable]="false"
                            [showAddressSection]="true" [showCircles]="false"
                            (eventHandle)="mapEventHandle($event)"></app-map>
                    </div>
                </div>
                <div *ngIf="config?.mode === 'view'" class="permitted-users">
                    <app-table-view [listType]="'assistants'" [controls]="tableControls"
                        (eventHandeler)="tableEventHandeler($event)">
                    </app-table-view>
                </div>
                <!-- <div *ngIf="config?.mode === 'view' && helpers?.length > 0" class="permitted-users">
                    <label>{{'edit-assistant.permitted-user' | translate}}</label>
                    <table class="table table-hover">
                        <thead class="user-head">
                            <tr>
                                <th scope="col">{{'edit-assistant.relative-name' | translate}}</th>
                                <th scope="col">{{'edit-assistant.national-id' | translate}}</th>
                                <th scope="col">{{'edit-assistant.role' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="user-row" *ngFor="let helper of helpers">
                                <td>
                                    <img [src]="getImage(helper.image_path)">
                                    <span>{{helper.name}}</span>
                                </td>
                                <td>{{helper.national_id}}</td>
                                <td>{{'edit-assistant.primary' | translate}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
            </div>
        </form>
    </div>
    <!-- <div class="footer">
        <button *ngIf="config?.mode === 'edit'" [disabled]="addAssistantForm.invalid" type="button"
            class="btn btn-primary save-btn" (click)="saveAssistant()">{{'edit-assistant.save' | translate}}</button>
    </div> -->
</div>